// import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { getSearchParams, getSearchResults, search } from 'b2b-common/services/api/hotel'
import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByHotDeal,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    rooms: [{ adults: 2, childAges: [] }],
    done: false
  },
  results: [],
  fees: {},

  generateFees () {
    const fees = {}
    for (let i = 5; i >= 0; i--) {
      fees[i] = {
        percent: 0,
        value: 0
      }
    }
    return fees
  },

  saveFees () {
    localStorage.setItem('hotelFees', JSON.stringify(this.fees))
  },

  async init ({ dc = null } = {}) {
    if (this.initDataLoaded && this.params.distribution === dc) return Promise.resolve(true)
    const params = getSearchParams({ dc: dc || this.distribution })
    const results = getSearchResults({ dc: dc || this.distribution })
    this.params = await params
    this.results = await results
    this.sort()
    const hotelFees = localStorage.getItem('hotelFees')
    if (hotelFees) this.fees = JSON.parse(hotelFees)
    else this.fees = this.generateFees()
    this.initDataLoaded = true
    return true
  },

  sort ({ sortMethod = sortByHotDeal } = {}) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ dc: params.distribution })
    this.params = newParams
    this.results = res
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
